module.exports = __webpack_public_path__ + "static/img/smaco-7.7db31e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg/smaco-7.jpg
// module id = 5k8c
// module chunks = 1